import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureFirstTouch } from '../lib/attribution'

/**
 * Captura a origem (UTM, click ids, referrer, página de entrada) de qualquer URL
 * pública e guarda por 30 dias em localStorage. Consumida pelo fluxo de signup.
 *
 * Montado no `App`, junto de `useReferralCapture`, e não em `RegisterForm`: numa
 * SPA a query string se perde na primeira navegação de rota. Quem chega em
 * `/lp/professor?utm_source=lp&fbclid=...` e só depois clica em "criar conta"
 * chegaria em `/register` sem nenhum parâmetro — que é exatamente o que
 * acontecia antes, com a LP mandando UTMs que o formulário descartava.
 *
 * `captureFirstTouch` não sobrescreve: o segundo toque não apaga o primeiro.
 */
export const useAttributionCapture = () => {
  const { search, pathname } = useLocation()

  useEffect(() => {
    captureFirstTouch(search, typeof document !== 'undefined' ? document.referrer : null, pathname)
  }, [search, pathname])
}
